module.exports = __webpack_public_path__ + "static/blob-corner-d6dd33372a71356f0e97c6766a67bf51.png";